// extracted by mini-css-extract-plugin
export default {"container":"ServiceStatus_container__iJNnp","slotText":"ServiceStatus_slotText__XB63W","noSlotText":"ServiceStatus_noSlotText__jG2z+"};